import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { WechatContactType } from "@packages/chat-sdk";

export interface WechatContactsPersistentStoreType {
  fromUserId?: string;
  userId?: string;
  roomId?: string;
  contactType?: WechatContactType;
  tabContactType?: WechatContactType;
}
export const wechatContactsPersistentStore =
  new Store<WechatContactsPersistentStoreType>(
    persist(
      () => ({
        fromUserId: undefined,
        userId: undefined,
        roomId: undefined,
        contactType: undefined,
        tabContactType: undefined,
      }),
      {
        name: storageKey.WECHAT_CONTACTS_STORAGE, // name of the item in the storage (must be unique)
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      }
    ) as any
  );

export const wechatContactsPersistentStoreActions = {
  selectContactOrRoom(payload: {
    fromUserId?: string;
    userId?: string;
    roomId?: string;
    contactType?: WechatContactType;
  }) {
    wechatContactsPersistentStore.set(payload);
  },
  selectTabContactType(tabContactType?: WechatContactType) {
    wechatContactsPersistentStore.set({
      tabContactType: tabContactType || WechatContactType.SINGLE,
    });
  },
  reset() {
    localStorage.removeItem(storageKey.WECHAT_CONTACTS_STORAGE);
  },
};
